import router from "../index";

export default [
  {
    path: "/TestBookingManage",
    component: () => import('../../views/PhysicalTest/TestBookingManage/TestBookingManage'),
    beforeEnter: (to, from, next) => {
      if (router.app.$cookies.get("user") === "admin")
        next();
      else
        router.replace("/home");
    },
    meta: {
      title: '体测预约管理'
    },
    children: [
      {
        path: '/',
        redirect: 'TestBookingManageList'
      },
      {
        path: 'TestBookingManageList',
        component: () => import('../../views/PhysicalTest/TestBookingManage/TestBookingManageList/TestBookingManageList'),
        meta: {
          title: '体测预约时间段列表'
        },
      }, {
        path: 'AddTestBooking',
        component: () => import('../../views/PhysicalTest/TestBookingManage/AddTestBooking/AddTestBooking'),
        meta: {
          title: '添加时间段'
        },
      }, {
        path: 'PhyTestStudents',
        component: () => import('../../views/PhysicalTest/TestBookingManage/PhyTestStudents/PhyTestStudents'),
        meta: {
          title: '预约学生'
        },
      },
    ]
  },
]
